import { createFileRoute } from "@tanstack/react-router";

// Handled by parent layout — this just registers the route
export const Route = createFileRoute("/assistant/$threadId")({
	component: () => null,
});
